import { utils } from '@costar/theme-ui';
import React from 'react';
import { isSelectOptionItem } from './utils.esm.js';

function singleSelectTextResolver () {
  var resolveText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (v) {
    return "".concat(v);
  };
  var flattenSelectionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (selection) {
    if (utils.isNotEmptyObject(flattenSelectionOptions)) {
      var curSelection = flattenSelectionOptions[selection];
      if (!curSelection) {
        return "".concat(selection);
      }
      if (typeof curSelection === 'string') {
        return curSelection;
      } else if (typeof curSelection.label === 'string') {
        return curSelection.label;
      } else {
        var stringNodes = isSelectOptionItem(curSelection) ? utils.extractStringNodes(React.Children.toArray(curSelection.label).filter(function (i) {
          return typeof i === 'string';
        })) : [];
        return "".concat(stringNodes);
      }
    }
    return resolveText(selection);
  };
}

export default singleSelectTextResolver;
//# sourceMappingURL=single-select-text-resolver.esm.js.map
